function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 14v3c0 1.66-1.34 3-3 3h-1c0-1.1-.9-2-2-2s-2 .9-2 2h-4c0-1.1-.9-2-2-2s-2 .9-2 2H5c-1.66 0-3-1.34-3-3v-3h11c1.1 0 2-.9 2-2V5h1.84c.72 0 1.38.39 1.74 1.01L20.29 9H19c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 22a2 2 0 100-4 2 2 0 000 4zm8 0a2 2 0 100-4 2 2 0 000 4zm6-9.47V14h-3c-.55 0-1-.45-1-1v-3c0-.55.45-1 1-1h1.29l1.45 2.54c.17.3.26.64.26.99zM14 2H6C4.05 2 2.43 3.4 2.08 5.25H7c.41 0 .75.34.75.75s-.34.75-.75.75H2v1.5h3c.41 0 .75.34.75.75s-.34.75-.75.75H2v1.5h1c.41 0 .75.34.75.75s-.34.75-.75.75H2V14h11c1.1 0 2-.9 2-2V3c0-.55-.45-1-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.08 5.25H1c-.41 0-.75.34-.75.75s.34.75.75.75h1V6c0-.26.03-.51.08-.75zM1 8.25c-.41 0-.75.34-.75.75s.34.75.75.75h1v-1.5H1zm0 3c-.41 0-.75.34-.75.75s.34.75.75.75h1v-1.5H1z"
})));